import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectAwardLetterTab } from '@backrs_ui/grow-ui/src/redux/tabs/tabs.slice';

import { AwardLetter } from './AwardLetter';

export const AwardLetterPanel = () => {
  const awardLetterTab = useAppSelector(selectAwardLetterTab);

  return awardLetterTab ? <AwardLetter userCollegeId={awardLetterTab.userCollegeId} /> : null;
};
